import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';
import Search from '../Search';

class ZipcodeSearch extends Component {

  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadSuggestions = this.loadSuggestions.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
  }

  onBlur(suggestion) {
    // For Zipcodes we want to freely allow them to enter it without making a choice from suggestions
    if (suggestion) {
      this.props.onSuggestionSelected(`${suggestion.zipcode}.${suggestion.code}`);
    }
  }

  onSuggestionSelected(e, { suggestion }) {
    if (suggestion === undefined) {
      this.props.onSuggestionSelected('');
      return;
    }

    this.props.onSuggestionSelected(`${suggestion.zipcode}.${suggestion.code}`);
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  getSuggestionValue(suggestion) {
    return suggestion.zipcode;
  }

  loadSuggestions(value) {
    const { limit } = this.props;

    this.props.setLoading(true);

    return Api.get('search/zipcodes', {
      params: {
        q: value,
        limit,
      },
    }).then((res) => {
      this.props.setLoading(false);
      this.setState({ suggestions: res.data || [] });
    });
  }

  handleSubmit(value) {
    if (!value) {
      this.props.onSuggestionSelected('', '');
    }
  }

  renderSuggestion(suggestion) {
    return (
      <div>
        <div>{suggestion.city}, {suggestion.county}, {suggestion.state}</div>
        <div>Zip: <b>{suggestion.zipcode}</b> Tax: <b>{suggestion.taxrate}</b> {suggestion.code}</div>
      </div>
    );
  }

  render() {
    return (
      <Search
        {...this.props}
        onSubmit={this.handleSubmit}
        onBlur={this.onBlur}
        onSuggestionSelected={this.onSuggestionSelected}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        suggestions={this.state.suggestions}
        loadSuggestions={this.loadSuggestions}
      />
    );
  }
}

ZipcodeSearch.defaultProps = {
  limit: 25,
  setLoading: () => {},
};

ZipcodeSearch.propTypes = {
  controlId: PropTypes.string,
  limit: PropTypes.number,
  onSuggestionSelected: PropTypes.func,
  setLoading: PropTypes.func,
  value: PropTypes.string,
};


export default ZipcodeSearch;
